import {
  select,
  put,
  takeEvery,
  takeLeading,
  takeLatest,
  all,
} from 'redux-saga/effects';
import {
  SET_CATEGORY,
  APPLY_UI_FILTER,
  RESET_UI_FILTER,
  RESET_FILTER,
} from '../../constants/filter';
import {
  applyUIFilter,
  setAppFilter,
  setUIFilter,
} from '../../actions/ui/filter';
// SELECTORS
import { appFilterSelector } from '../../reducers/app/filter';
import {
  initialState as uiFilterInitialState,
  uiFilterSelector,
} from '../../reducers/ui/filter';

export const IMMEDIATE_TRIGGER_ACTIONS = [SET_CATEGORY];
/**
 * Immediately synchronize app filter with ui filter
 * Used for desktop sidebar filter
 */
// immediate meta was removed. Take solution from pm-casino if it will be useful
export function* immediateFilterWorker() {
  yield put(applyUIFilter());
}

export const SYNC_TRIGGER_ACTIONS = [APPLY_UI_FILTER, RESET_UI_FILTER];
/**
 * Responsible only for syncing app filter with ui filter and backward.
 */
export function* syncFiltersWorker(action) {
  if (action.type === APPLY_UI_FILTER) {
    // get whole filter from UI state
    const filterFromUI = yield select(uiFilterSelector);
    // and rewrite APP filter
    yield put(setAppFilter(filterFromUI));
  }

  if (action.type === RESET_UI_FILTER) {
    // get whole APP filter
    const filterFromApp = yield select(appFilterSelector);
    // and reset UI filter
    yield put(setUIFilter(filterFromApp));
  }
}

export const CATEGORY_PARAM = 'category';

export function* resetFilterWorker(action) {
  const filter = { ...uiFilterInitialState };

  yield all([put(setAppFilter(filter)), put(setUIFilter(filter))]);
}

export function* filter() {
  yield takeLeading(SYNC_TRIGGER_ACTIONS, syncFiltersWorker);
  yield takeLatest(IMMEDIATE_TRIGGER_ACTIONS, immediateFilterWorker);
  yield takeEvery(RESET_FILTER, resetFilterWorker);
}
